import React from "react";
import "./WhatWeDo.css";
import SideImage from "../../../../assets/images/what-we-do.png";
import Tick from "../../../../assets/images/list-tick.png";
const WhatWeDo = () => {
  return (
    <div className="whatwedo__section">
      <div className="whatwedo__section_left">
        <div className="whatwedo__secleft_title">What we do</div>
        <div className="whatwedo__secleft_heading">
          we specialize in accounting and tax preparation services for a wide
          array of clients.
        </div>
        <div className="list__items">
          <div className="list__item">
            <img className="list__item_icon" src={Tick} alt="" />
            <div className="list__item_right">
              Our objective is to help our clients maintain financial viability
              in the present, while taking a proactive approach to achieve all
              their future goals
            </div>
          </div>
          <div className="list__item">
            <img className="list__item_icon" src={Tick} alt="" />
            <div className="list__item_right">
              Dedication – We believe this to be a direct derivative of our
              talent and responsiveness to our client base.
            </div>
          </div>
          <div className="list__item">
            <img className="list__item_icon" src={Tick} alt="" />
            <div className="list__item_right">
              Providing services that not only meet but exceed your expectations
            </div>
          </div>
          <div className="list__item">
            <img className="list__item_icon" src={Tick} alt="" />
            <div className="list__item_right">
              Use of the most current technology available in the accounting
              industry
            </div>
          </div>
          <div className="list__item">
            <img className="list__item_icon" src={Tick} alt="" />
            <div className="list__item_right">
              Communication, both with you and within our firm
            </div>
          </div>
          <div className="list__item">
            <img className="list__item_icon" src={Tick} alt="" />
            <div className="list__item_right">
              Constant evaluation of our processes and performance
            </div>
          </div>
        </div>
      </div>
      <div className="whatwedo__section_right">
        <img src={SideImage} alt="" className="whatwedo__section_img" />
      </div>
    </div>
  );
};

export default WhatWeDo;
